import {Injectable} from '@angular/core';
import {IResourceMethod, ResourceAction, ResourceHandler, ResourceParams, ResourceRequestMethod} from '@ngx-resource/core';
import {ResourceAuth} from '../../common.module/auth/authenticate.resource';
import {AuthServerProvider} from '../../common.module/auth/auth-jwt.service';
import {ConfiguracionGeneralModel} from './configuracion-general.model';
import {ConfiguracionTarjetaModel} from '../../admin.configuracion-tarjeta.module/service/configuracion-tarjeta.model';
import { ConfiguracionTarjetaTpvModel } from '../../admin.configuracion-tarjeta.module/service/configuracion-tarjeta-tpv.model';

@Injectable()
@ResourceParams({
  pathPrefix: '/configuracion'
  // url: 'http://localhost:8003'
})
export class ConfiguracionGeneralResource extends ResourceAuth {
  constructor(resourceHandler: ResourceHandler, authProv: AuthServerProvider) {
    super(resourceHandler, authProv);
  }

 /*export class ConfiguracionGeneralResource extends Resource {
   constructor(resourceHandler: ResourceHandler) {
   super(resourceHandler);
   }*/

  @ResourceAction({
    path: '/configuracion-general',
    method: ResourceRequestMethod.Patch
  })
  actualizarConfiguracionGeneral: IResourceMethod<ConfiguracionGeneralModel, any>;

  @ResourceAction({
    path: '/na/configuracion-general',
    method: ResourceRequestMethod.Get
  })
  obtenerConfiguracionGeneral: IResourceMethod<any, ConfiguracionGeneralModel>;

  @ResourceAction({
    path: '/na/configuracion-tarjeta-tia',
    method: ResourceRequestMethod.Get
  })
  obtenerConfiguracionTarjetaTia: IResourceMethod<any, ConfiguracionTarjetaModel>;

  /* TARJETAS TPV */
  @ResourceAction({
    path: '/na/configuracion-tarjeta-tpv',
    method: ResourceRequestMethod.Get

  })
  obtenerConfiguracionTarjetaTpv: IResourceMethod<any, ConfiguracionTarjetaTpvModel>;

  @ResourceAction({
    path: '/configuracion-tarjeta-tpv',
    method: ResourceRequestMethod.Patch
  })
  actualizarConfiguracionTarjetaTpv: IResourceMethod<ConfiguracionTarjetaTpvModel, any>;




}
